import React, {useEffect, useState} from 'react';
import {Button} from 'reactstrap';
import Swiper from "../Components/Swiper";
import Navbar from "../Components/Navbar";
import {useParams} from "react-router-dom";
import Footer from "../Components/Footer";
import axios from "../Config/axios";

function NewsDetail() {
    const [isMobile, setIsMobile] = useState(false);
    const [news, setNews] = useState();
    const {id} = useParams();
    const handleGoBack = () => {
        window.history.back(); // Go back to the previous page
        // window.location.href = '/previous-page'; // Alternatively, navigate to a specific route
    }
    useEffect(() => {

        const handleResize = () => {
            setIsMobile(window.outerWidth <= 768); // Adjust the breakpoint according to your needs
        };

        handleResize(); // Check initial width
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        axios
            .post("news/getById", {
                id: id
            })
            .then((res) => {
                let {code} = res.data;

                if (code === 200) {
                    setNews(res?.data?.data?.news);
                } else if (code === 400) {
                    setNews(res?.data?.data?.news);
                }
            })
            .catch(() => {
            });
    }, []);
    return (
        <div className={`background ${isMobile ? 'header-placement' : ''}`}>
            {!isMobile && <Swiper/>}
            <Navbar activeLink='news'/>
            <div className='wrapper'>
                <div className={'news-button-wrapper'}><Button color="link" onClick={handleGoBack}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         className="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path fillRule="evenodd"
                              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                    </svg>
                Буцах
                </Button></div>
                <div className='home-title'>{news?.title}</div>
                <div className={'news-wrapper'}>
                    <img
                        src={news?.image_url}
                        alt="" className={'news-image'}/>

                    <div className={'news-content'} style={{textAlign: 'justify'}}><div
                        dangerouslySetInnerHTML={{__html: news?.content}}
                    />
                    </div>


                </div>
                <Footer isMobile={isMobile}/>
            </div>
        </div>
    );
}

export default NewsDetail;